import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expression-undo",
  "use": "icon-expression-undo-usage",
  "viewBox": "0 0 15.199999809265137 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 15.199999809265137 16\" id=\"icon-expression-undo\"><g><path d=\"M4.8,6L4.8,8L0,4L4.8,0L4.8,3.2L8.8,3.2C12.3346,3.2,15.2,6.06538,15.2,9.6C15.2,13.1346,12.3346,16,8.8,16L1.6,16L1.6,13.2L8.8,13.2C11.451,13.2,12.8,12.251,12.8,9.6C12.8,6.94903,11.451,6,8.8,6L4.8,6Z\" fill=\"currentColor\" fill-opacity=\"0.6499999761581421\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol